function Button (props){
  return(
<button type="submit" className="submit">{props.text}</button>
  )
}
export default Button ;